import * as React from 'react';
import { Component } from 'react';
import './Policy.css';
import { RouteComponentProps } from 'react-router';
import NavMenu from '../NavMenu/NavMenu';
import Footer from '../../components/Login/Footer';

interface IProps extends RouteComponentProps<any> {
    OnAccept: () => void,
    OnAbort: () => void
}

export class Policy extends Component<IProps, any> {
    constructor(props) {
        super(props);

    }

    public render() {
        return (
            <div className="policy-container ">
                <NavMenu
                    history={this.props.history}
                    HideMenu={true} />
                <div className="title">
                    <h3>Polityka prywatności</h3>
                </div>
                <div className="privacy-wrapper">
                    <div className="privacy-wrapper__title">
                        <div className="privacy-wrapper__square" />
                        <p className="privacy-wrapper__text">Warunki ogólne</p>
                    </div>
                    <ul className="privacy-wrapper__list">
                        <li className="privacy-wrapper__list-item">
                            <span>1.</span> <p>Niniejsza Polityka Prywatności informuje o sposobach przetwarzania Twoich danych osobowych i ich ochrony w ramach serwisu znajdującego się pod adresem elektronicznym www.kif.info.pl zwanego dalej „Serwisem”.</p>
                        </li>
                        <li>
                            <span>2.</span> <p>Administratorem Twoich danych osobowych jest Krajowa Izba Fizjoterapeutów z siedzibą w Warszawie (00-066 Warszawa) pl. Stanisława Małachowskiego 2, posiadająca numer REGON 366272350, numer identyfikacji podatkowej (NIP) 7010651576.</p>
                        </li>
                        <li>
                            <span>3.</span> <p>Zawartość stron Serwisu stanowi własność Administratora danych i jest prawnie chroniona.</p>
                        </li>
                        <li>
                            <span>4.</span><p>W celu korzystania z Serwisu powinieneś posiadać komputer lub urządzenie z zainstalowanym oprogramowaniem pozwalającym na przeglądanie stron internetowych oraz dostęp do sieci Internet. Dostęp do Serwisu może odbywać się przy wykorzystaniu najpopularniejszych przeglądarek internetowych.</p>
                        </li>
                        <li>
                            <span>5.</span> <p>Administrator oświadcza, że strony Serwisu są wolne od treści naruszających prawa osób trzecich lub obowiązujące przepisy prawa, a w szczególności od treści zawierających informacje, które powodują lub stanowią zagrożenie prywatności lub bezpieczeństwa jakichkolwiek osób, zawierających informacje promujące nielegalne działania bądź zachowania, które są obraźliwe, stanowią groźbę, są nieprzyzwoite, zniesławiające lub oszczercze, wzbudzające rasizm, prześladowanie z przyczyn etnicznych, kulturowych bądź religijnych, promujących lub sprzyjających działaniom przestępczym, naruszających prawa osób trzecich, w tym prawa własności intelektualnej lub stanowiące inną formę naruszenia dóbr prawnie chronionych.</p>
                        </li>
                        <li>
                            <span>6.</span><p>Serwis może zawierać linki do stron osób trzecich. Strony internetowe osób trzecich mają swoją własną politykę prywatności. Odwiedzając te strony, podlegasz tym politykom.</p>
                        </li>
                    </ul>
                    <div className="privacy-wrapper__title">
                        <div className="privacy-wrapper__square" />
                        <p className="privacy-wrapper__text">Przetwarzanie danych osobowych</p>
                    </div>
                    <ul className="privacy-wrapper__list">
                        <li className="privacy-wrapper__list-item">
                            <span>1.</span> <p>Gromadzimy Twoje dane osobowe w momencie, gdy dostarczasz je nam bezpośrednio poprzez formularz rejestracyjny, kontaktowy bądź korzystając z naszego Serwisu lub innych administrowanych przez nas stron internetowych a także, gdy zgadzasz się na korzystanie z plików cookies. Administrator przetwarza zatem dane obejmujące m.in. Twoje imię, nazwisko, adres e-mail, płeć, adres IP a także numer PWZ. Każdorazowo podczas wypełnienia oddzielnego formularza zostaniesz poinformowany za pomocą klauzuli obowiązku informacyjnego o zakresie niezbędnych danych osobowych oraz celu ich przetwarzania.</p>
                        </li>
                        <li>
                            <span>2.</span> <p>We wszelkich sprawach związanych z przetwarzaniem Twoich danych osobowych możesz skontaktować się z naszym Inspektorem Ochrony Danych, Panią Katarzyną Pisarzewska za pośrednictwem adresu e-mail: iod@kif.info.pl.</p>
                        </li>
                        <li>
                            <span>3.</span> <p>Podanie danych i korzystanie z Serwisu jest całkowicie bezpłatne oraz dobrowolne.</p>
                        </li>

                    </ul>
                    <div className="privacy-wrapper__title">
                        <div className="privacy-wrapper__square" />
                        <p className="privacy-wrapper__text">Dostęp do danych</p>
                    </div>
                    <ul className="privacy-wrapper__list">
                        <li className="privacy-wrapper__list-item">
                            <span>1.</span> <p>Do danych osobowych przetwarzanych przez Administratora mają bezpośredni dostęp jedynie upoważnieni pracownicy lub współpracownicy Administratora oraz uprawnione osoby zajmujące się obsługą Serwisu, którym zostały udzielone stosowne upoważnienia a które zobowiązały się do zachowania w poufności przetwarzane dane.</p>
                        </li>
                        <li>
                            <span>2.</span> <p>Dane osobowe użytkowników Serwisu mogą być udostępniane podmiotom uprawnionym do ich otrzymania na mocy obowiązujących przepisów prawa, a w szczególności właściwym organom wymiaru sprawiedliwości.</p>
                        </li>
                        <li>
                            <span>3.</span> <p>Do danych osobowych przetwarzanych przez Administratora mają bezpośredni dostęp jedynie upoważnieni pracownicy lub współpracownicy Administratora oraz uprawnione osoby zajmujące się obsługą Serwisu, którym zostały udzielone stosowne upoważnienia a które zobowiązały się do zachowania w poufności przetwarzane dane.</p>
                        </li>
                        <li>
                            <span>4.</span><p>Dane osobowe użytkowników Serwisu mogą być udostępniane podmiotom uprawnionym do ich otrzymania na mocy obowiązujących przepisów prawa, a w szczególności właściwym organom wymiaru sprawiedliwości.</p>
                        </li>
                    </ul>
                </div>
                <Footer />
            </div>

        );
    }


}


// WEBPACK FOOTER //
// ./src/components/Statute/Policy.tsx